import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from '@emotion/react'; // Zaktualizowany import
import { themed } from '../theme'; // Zakładam, że theme.js jest dostosowany do @emotion/react

export const IconRenderer = themed({
  tag: 'svg',
  defaultProps: {
    focusable: 'false', // Wyłącza fokus dla SVG
  },
  defaultTheme: {
    icon: {
      size: 'lg',
      stroke: 'primary',
    },
  },
});

const IconComponent = ({ src, fallback, theme, ...rest }) => {
  if (!theme || !theme.icons) {
    console.warn('IconComponent: Theme or theme.icons is undefined');
    return fallback || null;
  }

  const icons = theme.icons;

  if (!src || !icons[src]) {
    return fallback || null;
  }

  const { icon, ...otherProps } = icons[src];

  return <IconRenderer as={icon} {...otherProps} {...rest} />;
};

IconComponent.propTypes = {
  src: PropTypes.string.isRequired,
  fallback: PropTypes.node,
  theme: PropTypes.shape({
    icons: PropTypes.object.isRequired,
  }).isRequired,
};

export const Icon = withTheme(IconComponent);

export default Icon;